import { CustomerStatus } from "Store/userIdentification/userIdentificationInterfaces";

const statuses = Object.keys(CustomerStatus);
export const customerStatusToIndex = (
  customerStatus: CustomerStatus,
): number => {
  return statuses.indexOf(customerStatus);
};

export const indexToCustomerStatus = (
  index: number,
): CustomerStatus | undefined => {
  return statuses[index] as CustomerStatus;
};
